'use client';

import { useEffect, useState } from 'react';
import AppLogo from '@/components/ui/AppLogo';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToQuiz = () => {
    document.getElementById('quiz')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 px-6 md:px-12 py-4 flex items-center justify-between ${
        scrolled ? 'nav-scrolled' : ''
      }`}
    >
      <AppLogo
        text="Synapse"
        size={32}
        iconName="AcademicCapIcon"
        className="cursor-pointer"
      />

      <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-ink-light">
        <a href="#study-path" className="hover:text-green transition-colors">Study Path</a>
        <a href="#quiz" className="hover:text-green transition-colors">Diagnostic</a>
        <a href="#plan" className="hover:text-green transition-colors">Study Plan</a>
      </nav>

      <button
        onClick={scrollToQuiz}
        className="btn-amber px-5 py-2.5 rounded-full text-sm"
      >
        Find Your Weak Spots
      </button>
    </header>
  );
}